import { createIcon } from '../createIcon'

export const TwitterIcon = createIcon(
  <path d="M5.218 12.519c5.66 0 8.756-4.69 8.756-8.757 0-.133 0-.266-.01-.397A6.261 6.261 0 0 0 15.5 1.77a6.143 6.143 0 0 1-1.768.485A3.089 3.089 0 0 0 15.085.552a6.169 6.169 0 0 1-1.954.747 3.08 3.08 0 0 0-5.244 2.808A8.738 8.738 0 0 1 1.544.89 3.08 3.08 0 0 0 2.497 5 3.054 3.054 0 0 1 1.1 4.615v.04A3.079 3.079 0 0 0 3.569 7.67a3.071 3.071 0 0 1-1.39.052 3.081 3.081 0 0 0 2.876 2.138A6.175 6.175 0 0 1 .5 11.136a8.713 8.713 0 0 0 4.718 1.38" />,
  'TwitterIcon',
  '0 0 16 13',
)
